const carMakes = [
  { id: 1, name: "Acura", value: "acura" },
  { id: 2, name: "Audi", value: "audi" },
  { id: 3, name: "Bentley", value: "bentley" },
  { id: 4, name: "BMW", value: "bmw" },
  { id: 5, name: "Buick", value: "buick" },
  { id: 6, name: "Cadillac", value: "cadillac" },
  { id: 7, name: "Chevrolet", value: "chevrolet" },
  { id: 8, name: "Chrysler", value: "chrysler" },
  { id: 9, name: "Dodge", value: "dodge" },
  { id: 10, name: "Fiat", value: "fiat" },
  { id: 11, name: "Ford", value: "ford" },
  { id: 12, name: "GMC", value: "gmc" },
  { id: 13, name: "Honda", value: "honda" },
  { id: 14, name: "Hyundai", value: "hyundai" },
  { id: 15, name: "Infiniti", value: "infiniti" },
  { id: 16, name: "Jaguar", value: "jaguar" },
  { id: 17, name: "Jeep", value: "jeep" },
  { id: 18, name: "Kia", value: "kia" },
  { id: 19, name: "Lamborghini", value: "lamborghini" },
  { id: 20, name: "Lexus", value: "lexus" },
  { id: 21, name: "Lincoln", value: "lincoln" },
  { id: 22, name: "Maserati", value: "maserati" },
  { id: 23, name: "Mazda", value: "mazda" },
  { id: 24, name: "Mercedes-Benz", value: "mercedes-benz" },
  { id: 25, name: "Mini", value: "mini" },
  { id: 26, name: "Mitsubishi", value: "mitsubishi" },
  { id: 27, name: "Nissan", value: "nissan" },
  { id: 28, name: "Porsche", value: "porsche" },
  { id: 29, name: "Rolls-Royce", value: "rolls-royce" },
  { id: 30, name: "Scion", value: "scion" },
  { id: 31, name: "Smart", value: "smart" },
  { id: 32, name: "Subaru", value: "subaru" },
  { id: 33, name: "Toyota", value: "toyota" },
  { id: 34, name: "Volkswagen", value: "volkswagen" },
  { id: 35, name: "Volvo", value: "volvo" },
];

export default [...carMakes];
